var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-0 pt-sm-1 d-xs-none",style:(_vm.loginBanner && _vm.loginBanner.generatedName
    ? {
        backgroundImage:
          'url(/api/image/get/' + _vm.loginBanner.generatedName + ')'
      }
    : {
        backgroundImage:
          'url(' + require('@/assets/images/background/back.png') + ')'
      }),attrs:{"id":"auth-container"}},[_c('div',{staticClass:"account-pages my-0 pt-0 my-sm-5 pt-sm-5"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }